import DriverPortal from 'containers/DriverPortalPage';
import MainPage from 'containers/DriverPortalPage/MainPage';
import BookBankPage from 'containers/DriverPortalPage/MainPage/BookBankPage';
import DriverLicensePage from 'containers/DriverPortalPage/MainPage/DriverLicensePage';
import HouseRegistrationPage from 'containers/DriverPortalPage/MainPage/HouseRegistrationPage';
import IdentityPage from 'containers/DriverPortalPage/MainPage/IdentityPage';
import OnlineTrainingPage from 'containers/DriverPortalPage/MainPage/OnlineTrainingPage';
import OnlineTrainingSuccessPage from 'containers/DriverPortalPage/MainPage/OnlineTrainingPage/Success';
import PersonalInformationPage from 'containers/DriverPortalPage/MainPage/PersonalInformationPage';
import VaccinationCertificatePage from 'containers/DriverPortalPage/MainPage/VaccinationCertificatePage';
import VehicleInformationPage from 'containers/DriverPortalPage/MainPage/VehicleInformationPage';
import VoluntaryInsuranceUploadPage from 'containers/DriverPortalPage/MainPage/VoluntaryInsuranceUploadPage';
import OTPPage from 'containers/DriverPortalPage/OTPPage';
import PrivacyPolicyPage from 'containers/DriverPortalPage/PrivacyPolicyPage';
import TermsAndConditionPage from 'containers/DriverPortalPage/TermsAndConditionPage';
import ForbiddenPage from '../containers/ForbiddenPage';

export interface IRouteConfig {
  title: string;
  path: string;
  component: unknown;
  exact: boolean;
  isPrivate: boolean;
}

const RouteConfigs: IRouteConfig[] = [
  {
    title: 'Forbidden',
    path: '/forbidden',
    component: ForbiddenPage,
    exact: true,
    isPrivate: false,
  },
  {
    title: 'Rider Portal',
    path: '/login',
    component: DriverPortal,
    exact: true,
    isPrivate: false,
  },
  {
    title: 'Rider Portal',
    path: '/signup',
    component: DriverPortal,
    exact: true,
    isPrivate: false,
  },
  {
    title: 'Rider Portal',
    path: '/otp',
    component: OTPPage,
    exact: true,
    isPrivate: false,
  },
  {
    title: 'Rider Portal',
    path: '/privacy-policy',
    component: PrivacyPolicyPage,
    exact: true,
    isPrivate: false,
  },
  {
    title: 'Rider Portal',
    path: '/driver/terms-condition',
    component: TermsAndConditionPage,
    exact: true,
    isPrivate: false,
  },
  {
    title: 'Rider Portal',
    path: '/',
    component: MainPage,
    exact: true,
    isPrivate: true,
  },
  {
    title: 'Rider Portal',
    path: '/personal-information',
    component: PersonalInformationPage,
    exact: true,
    isPrivate: true,
  },
  {
    title: 'Rider Portal',
    path: '/vehicle-information',
    component: VehicleInformationPage,
    exact: true,
    isPrivate: true,
  },
  {
    title: 'Rider Portal',
    path: '/identity',
    component: IdentityPage,
    exact: true,
    isPrivate: true,
  },
  {
    title: 'Rider Portal',
    path: '/driver-license',
    component: DriverLicensePage,
    exact: true,
    isPrivate: true,
  },
  {
    title: 'Rider Portal',
    path: '/book-bank',
    component: BookBankPage,
    exact: true,
    isPrivate: true,
  },
  {
    title: 'Rider Portal',
    path: '/medical-certificate',
    component: VaccinationCertificatePage,
    exact: true,
    isPrivate: true,
  },
  {
    title: 'Rider Portal',
    path: '/online-training',
    component: OnlineTrainingPage,
    exact: true,
    isPrivate: true,
  },
  {
    title: 'Rider Portal',
    path: '/online-training/success',
    component: OnlineTrainingSuccessPage,
    exact: true,
    isPrivate: false,
  },
  {
    title: 'ประกันภาคสมัครใจ',
    path: '/voluntary-insurance',
    component: VoluntaryInsuranceUploadPage,
    exact: true,
    isPrivate: true,
  },
  {
    title: 'ทะเบียนบ้าน',
    path: '/house-registration',
    component: HouseRegistrationPage,
    exact: true,
    isPrivate: true,
  },
];

export default RouteConfigs;
